// extracted by css-extract-rspack-plugin
export default {"AppSelectionRow":"AppSelectionRow-HVM7mT","appSelectionRow":"AppSelectionRow-HVM7mT","AppSelection":"AppSelection-o7egVB","appSelection":"AppSelection-o7egVB"};